var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      staticStyle: { width: "auto", "min-height": "70vh" },
    },
    [
      _vm._m(0),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "div",
            { staticClass: "mb-5" },
            [
              _c(
                "b-field",
                { attrs: { label: "Serial number(Optional)" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.device.serialNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.device, "serialNumber", $$v)
                      },
                      expression: "device.serialNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mb-5" },
            [
              _c(
                "b-field",
                { attrs: { label: "Type" } },
                [
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "plant" },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    [_vm._v(" Plant ")]
                  ),
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "customer" },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    [_vm._v(" Customer ")]
                  ),
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "producer" },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    [_vm._v(" Producer ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "mb-5" }, [
            _vm.type === "plant"
              ? _c(
                  "div",
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.$lodash.orderBy(_vm.plants, ["name"]),
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick plant...",
                            "custom-label": _vm.getLabel,
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.assginedTo,
                            callback: function ($$v) {
                              _vm.assginedTo = $$v
                            },
                            expression: "assginedTo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type === "customer"
              ? _c(
                  "div",
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "Customer" } },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.customerMenu,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick customer...",
                            "custom-label": _vm.getLabel,
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.assginedTo,
                            callback: function ($$v) {
                              _vm.assginedTo = $$v
                            },
                            expression: "assginedTo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.type === "producer"
              ? _c(
                  "div",
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "Producer" } },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.$lodash.orderBy(_vm.plants, ["name"]),
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick producer...",
                            "custom-label": _vm.getLabel,
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.assginedTo,
                            callback: function ($$v) {
                              _vm.assginedTo = $$v
                            },
                            expression: "assginedTo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.type === "customer"
            ? [
                _c("hr"),
                _c("p", { staticClass: "title is-6" }, [
                  _vm._v(" Device Configuration "),
                ]),
                _c(
                  "b-field",
                  { attrs: { label: "Reference Required" } },
                  [
                    _c("b-switch", {
                      model: {
                        value: _vm.deviceConfig.referenceRequired,
                        callback: function ($$v) {
                          _vm.$set(_vm.deviceConfig, "referenceRequired", $$v)
                        },
                        expression: "deviceConfig.referenceRequired",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Auto Sync" } },
                  [
                    _c("b-switch", {
                      model: {
                        value: _vm.deviceConfig.autoSyncEnabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.deviceConfig, "autoSyncEnabled", $$v)
                        },
                        expression: "deviceConfig.autoSyncEnabled",
                      },
                    }),
                  ],
                  1
                ),
                _c("b-field", { attrs: { label: "Allowed Movement Types" } }, [
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    _vm._l(_vm.mvtTypes, function (mvt) {
                      return _c(
                        "b-checkbox-button",
                        {
                          key: mvt.code,
                          attrs: { "native-value": mvt.code, type: "is-info" },
                          model: {
                            value: _vm.deviceConfig.allowedMvt,
                            callback: function ($$v) {
                              _vm.$set(_vm.deviceConfig, "allowedMvt", $$v)
                            },
                            expression: "deviceConfig.allowedMvt",
                          },
                        },
                        [_vm._v(" " + _vm._s(mvt.code) + " ")]
                      )
                    }),
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.qrCodeGenerated
            ? _c(
                "div",
                { staticStyle: { "min-height": "150px" } },
                [
                  _c("canvas", {
                    staticClass: "block",
                    attrs: { id: "qrcode" },
                  }),
                  _c("b-button", {
                    attrs: { "icon-left": "download" },
                    on: { click: _vm.downloadQRCode },
                  }),
                  _c("p", [
                    _vm._v("New device registration code: "),
                    _c("strong", [_vm._v(_vm._s(_vm.device.registrationCode))]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          { staticClass: "buttons ml-auto" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-info",
                  disabled: !_vm.type || !_vm.assginedTo,
                },
                on: { click: _vm.generateCode },
              },
              [_vm._v(" Generate code ")]
            ),
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-primary",
                  loading: _vm.isLoading,
                  disabled: !_vm.device.registrationCode,
                },
                on: { click: _vm.submit },
              },
              [_vm._v(" Submit ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Add new device "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }